function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.labelPlugin = factory());
})(this, function () {
  'use strict';

  function labelPlugin() {
    return function (fp) {
      return {
        onReady: function onReady() {
          var id = fp.input.id;
          if (!id) {
            return;
          }
          if (fp.mobileInput) {
            fp.input.removeAttribute("id");
            fp.mobileInput.id = id;
          } else if (fp.altInput) {
            fp.input.removeAttribute("id");
            fp.altInput.id = id;
          }
          fp.loadedPlugins.push("labelPlugin");
        }
      };
    };
  }
  return labelPlugin;
});